import { createFileRoute } from "@tanstack/react-router";
import { OverviewPage, RANGES, VIEWS, type OverviewSearch } from "@/features/overview/page";

export const Route = createFileRoute("/_app/")({
  validateSearch: (search: Record<string, unknown>): OverviewSearch => ({
    range: typeof search.range === "string" && search.range in RANGES ? (search.range as OverviewSearch["range"]) : undefined,
    project: typeof search.project === "string" && search.project ? search.project : undefined,
    view:
      typeof search.view === "string" && (VIEWS as readonly string[]).includes(search.view) && search.view !== "overview"
        ? (search.view as OverviewSearch["view"])
        : undefined,
  }),
  component: OverviewPage,
});
